import { post } from '@tencent/pmd-network';

// const HOST_MAP = {
//   TEST: 'https://atest.igame.qq.com',
//   RELEASE: 'https://a.igame.qq.com',
// };

// function getHost() {
//   const debugEnv = window.sessionStorage.getItem('tip_debug_cgi_env');
//   if ((location.href.indexOf('h5-test') !== -1 || location.href.indexOf('h5-dev') !== -1)
//      && debugEnv !== 'prod') {
//     return HOST_MAP.TEST;
//   }
//   return HOST_MAP.RELEASE;
// }

export function getRoleList({
  gid = 331,
  plat = 0,
  device = 0,
}) {
  // return Promise.resolve([]);
  return new Promise((resolve, reject) => {
    post({
      // url: `${getHost()}/pmdtrpc.commcgi.tipcgi.tipcgi/QueryRoleList`,
      url: '/PromoPlatform.Game.exchange.exchange/QueryRoleList',
      reqData: {
        gid,
        plat,
        device,
      },
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}
